// app/javascript/projects/components/CodeDragLayer.jsx

import React from 'react';
import { useDragLayer } from 'react-dnd';
import { useCodeDragChildren } from 'hooks/codes/useCodeDragChildren';
import CodeLabelBody from './CodeLabelBody';

const layerStyles = {
  position: 'fixed',
  pointerEvents: 'none',
  zIndex: 100,
  left: 0,
  top: 0,
};

function getItemStyles(currentOffset) {
  if (!currentOffset) {
    return {
      display: 'none'
    };
  }

  const { x, y } = currentOffset;
  const transform = `translate(${x}px, ${y}px)`;

  return {
    transform: transform,
    WebkitTransform: transform
  };
}


function CodeDragLayer({ projectId }) {
  // Use drag layer hook
  const {
    item,
    currentOffset,
    isDragging,
  } = useDragLayer((monitor) => ({
    item: monitor.getItem(),
    currentOffset: monitor.getSourceClientOffset(),
    isDragging: monitor.isDragging(),
  }));

  // Get visible codes for the dragged item using the new hook
  const { codes: draggedCodes } = useCodeDragChildren(projectId, item?.codeID);


  const renderItem = () => {
    const MAX_CODE_NUMBER = 17;
    const codes = draggedCodes.slice(0, MAX_CODE_NUMBER);

    const renderCodes = codes.map((code, index) => (
      <div
        style={{
          marginLeft: (code.level || 0) * 30,
          marginBottom: "5px"
        }}
        key={code.id || index}
      >
        <CodeLabelBody name={code.name} />
      </div>
    ));

    return (
      <div style={{ opacity: 0.5 }}>
        {renderCodes}
      </div>
    );
  };

  if (!isDragging) return null;

  return (
    <div style={layerStyles}>
      <div style={getItemStyles(currentOffset)}>
        {renderItem()}
      </div>
    </div>
  );
}

export default CodeDragLayer;